/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_To_LabelInputs */



/**
* | output |
* | --- |
* | "To" |
*
* @param {Event_Group_Sync_To_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_to_label = /** @type {((inputs?: Event_Group_Sync_To_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_To_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("To")
	if (locale === "de") return /** @type {LocalizedString} */ ("To")
	if (locale === "it") return /** @type {LocalizedString} */ ("To")
	if (locale === "ru") return /** @type {LocalizedString} */ ("To")
	if (locale === "es") return /** @type {LocalizedString} */ ("To")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("To")
	if (locale === "ja") return /** @type {LocalizedString} */ ("To")
	if (locale === "hi") return /** @type {LocalizedString} */ ("To")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("To")
	return /** @type {LocalizedString} */ ("To")
});